import { render, staticRenderFns } from "./ResponseSchemaSection.vue?vue&type=template&id=992b02b8&"
import script from "./ResponseSchemaSection.vue?vue&type=script&lang=js&"
export * from "./ResponseSchemaSection.vue?vue&type=script&lang=js&"
import style0 from "./ResponseSchemaSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports